import { render, staticRenderFns } from "./CargaGlobal.vue?vue&type=template&id=4a62e915&scoped=true&"
import script from "./CargaGlobal.vue?vue&type=script&lang=js&"
export * from "./CargaGlobal.vue?vue&type=script&lang=js&"
import style0 from "./CargaGlobal.vue?vue&type=style&index=0&id=4a62e915&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a62e915",
  null
  
)

export default component.exports